// extracted by mini-css-extract-plugin
module.exports = {"title":"InvoiceFaq_title__1c1Wr"};